<template>
  <div class="wl-results" v-if="doc">
    <results-bar :doc="doc" @loadSummary="loadSummary" @loadUser="loadUser" :includeAdmin="true"></results-bar>
    <results-summary v-if="summary" :id="doc.id"></results-summary>
    <results-user v-if="!summary" :uid="currentUser" :id="doc.id"></results-user>
  </div>
</template>

<script>

import {
  ResultsSummary, ResultsUser, ResultsBar
} from "@/components/results/structure";

export default {
  name: "StructureResults",
  props: {
    doc: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      summary: true,
      summaryMode: "popular",
      currentUser: null,
      userList: null
    };
  },
  components: {
    ResultsSummary, ResultsUser, ResultsBar
  },
  methods: {
    loadSummary(mode) {
      this.currentUser = null;
      this.summaryMode = mode;
      this.summary = true;
    },
    loadUser(uid) {
      this.currentUser = uid;
      this.summary = false;
    }
  },
};
</script>
